import API from "../helpers/interceptor";

export function authenticate() {
  const azureToken = sessionStorage.getItem('AzureToken');
  const existingSessionId = sessionStorage.getItem('SessionId') || null;
  const tenantId = sessionStorage.getItem('TenantId') || null;
  return API.post('/login/authenticate', { existingSessionId, tenantId }, {
    headers: { Authorization: 'Bearer ' + azureToken },
  });
}

// Guard for regular API calls - ensures division is set
export function requireDivision() {
  const division = sessionStorage.getItem('Division');
  if (!division) {
    sessionStorage.clear();
    window.location.href = '/';
    return false;
  }
  return true;
}

export async function getAllUsers() {
  return API.post('/user/getusers', {});
}

export const addNewUser = async (user) => {
  return await API.post("/user/update", user);
};

export const getUserById = async (userId) => {
  return API.post("/user/getusers", { userId: userId });
};

export const saveUser = async (userId) => {
  return API.post("/user/update", { userId: userId });
};

export const getUserHistory = async (userId) => {
  return API.post("/user/getuserhistory", { userId: userId });
};

export const getASMUsers = async () => {
  return API.post("/user/getasmusers");
};

export const getAllDealers = async () => {
  return API.get("/iod-user/all-dealers");
};

export const getIodUser = async (userId) => {
  return API.post("/iod-user/get", { userId });
};

export const saveIodUser = async (user) => {
  return API.post("/iod-user/save", user);
};

export const toggleIodUserStatus = async (userId, status) => {
  return API.post("/iod-user/toggle-status", { userId, status });
};

export const getIodUserHistory = async (userId) => {
  return API.post("/iod-user/history", { userId });
};
